// Aug 3
export const SHORT_DAY__YEARLESS_MASK = 'LLL d'
// Aug 3, 2020
export const SHORT_DAY_MASK = 'LLL d, yyyy'
// 1:32 pm
export const TIME_MASK = 'h:mm aaa'
// 1:32 pm on Wed, Aug 3
export const TIME_DAY_MASK = `${TIME_MASK} 'on' EEE, MMM d`
// 1:32 pm on Wed, Aug 3, 2020
export const TIME_DAY_YEAR_MASK = `${TIME_DAY_MASK}, yyyy`

// if two items are within this number of seconds of each other
// we treat them as being edited at the same time so that sort
// orders don't go crazy when sorting by "recently edited"
export const SAME_TIME_DIFF_IN_SECONDS = 10
